import {MOVE_POI} from '../actions/types';

export default function movePoiReducer(state = [], action) {
    switch (action.type) {
        case MOVE_POI:
            return action.payload;
        default:
            return state;
    }
}
